<template>
    <search-select v-bind="$attrs" :options="options" :allow-empty="false" :searchable="false" label="name" :loading="loading" placeholder="Базовая ставка НДС" v-on="listeners" @input="$emit('input', $event)">
        <template slot="option" slot-scope="scope">
            <div class="d-flex align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
            </div>
        </template>

        <template slot="singleLabel" slot-scope="scope">
            <div class="d-flex align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
            </div>
        </template>
    </search-select>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import SearchSelect from '@/components/Select'

const state = new Vue.observable({
    loaded: false,
    loading: false,
    options: []
})

export const fetchVats = async () => {
    if (!state.loaded && !state.loading) {
        state.loading = true

        const response = await axios.get('api/reference/vats')
        state.options = response.data
        state.loaded = true

        state.loading = false
    }
}

export const getVatText = value => {
    const option = state.options.find(option => option.id === parseInt(value))
    return option ? option.name : null
}

export default {
    components: {
        SearchSelect
    },

    inheritAttrs: false,

    computed: {
        options() {
            return state.options
        },

        loading() {
            return state.loading
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        }
    },

    async created() {
        await fetchVats()
    }
}
</script>
